export default __webpack_public_path__ + "static/media/gmail.c1fd461f.svg";